module.exports = __webpack_public_path__ + "static/media/2.bcde5b3c.jpg";